import { createAsyncThunk } from '@reduxjs/toolkit';
import { authService } from '../../services/api';

export const loginUser = createAsyncThunk(
  'auth/login',
  async (credentials, { rejectWithValue }) => {
    try {
      const response = await authService.login(credentials);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Login failed');
    }
  }
);

export const registerUser = createAsyncThunk(
  'auth/register',
  async (userData, { rejectWithValue }) => {
    try {
      const response = await authService.register(userData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Registration failed');
    }
  }
);

export const logoutUser = createAsyncThunk(
  'auth/logout',
  async () => {
    authService.logout();
    return null;
  }
);

export const checkAuthStatus = createAsyncThunk(
  'auth/checkStatus',
  async (_, { getState, rejectWithValue }) => {
    try {
      const { token } = getState().auth;

      if (!token) {
        return rejectWithValue('No token found');
      }

      // Validate token by fetching user profile
      const response = await authService.getProfile();
      return response.data;
    } catch (error) {
      // Token is invalid or expired — clear it
      localStorage.removeItem('token');
      return rejectWithValue('Authentication check failed');
    }
  }
);

export const handleOAuthCallback = createAsyncThunk(
  'auth/oauthCallback',
  async (token, { dispatch }) => {
    if (token) {
      localStorage.setItem('token', token);

      try {
        const response = await authService.getProfile();
        return {
          user: response.data,
          access_token: token
        };
      } catch (error) {
        throw new Error('Failed to get user profile');
      }
    } else {
      throw new Error('No token received from OAuth provider');
    }
  }
);
